import React, { useEffect, useState } from 'react';
import './PerformanceDashboard.css';
import { BackButton } from '../../../Utilities/components/Buttons';
import Footer from '../../../Footer';

const PerformanceDashboard = () => {
  const [metrics, setMetrics] = useState({
    tasksCompleted: 0,
    petsHandled: 0,
    onTimePercent: 0,
    trainingProgress: '0/0',
    clientRating: 0,
    achievements: []
  });

  useEffect(() => {
    // Replace with actual API integration later
    setMetrics({
      tasksCompleted: 42,
      petsHandled: 76,
      onTimePercent: 96,
      trainingProgress: '9/10',
      clientRating: 4.8,
      achievements: ['Top Groomer - May', '5-Star Streak', 'Punctual Pro']
    });
  }, []);

  return (
    <div>
      <div className="container">
        <BackButton />
        <div className="performance-dashboard-container">
          <h2 className="performance-header">📊 Performance Overview</h2>
          <p className="performance-role-path">Your recent contribution snapshot</p>

          {/* Key Metrics Section */}
          <div className="performance-section">
            <div className="performance-section-title">📌 Key Metrics</div>
            <div className="performance-module-grid">
              <div className="performance-module-card completed">
                <div className="performance-module-title">Tasks Completed</div>
                <div className="performance-status-completed">{metrics.tasksCompleted}</div>
              </div>
              <div className="performance-module-card completed">
                <div className="performance-module-title">Pets Handled</div>
                <div className="performance-status-completed">{metrics.petsHandled}</div>
              </div>
              <div className="performance-module-card completed">
                <div className="performance-module-title">On-Time Clock-Ins</div>
                <div className="performance-status-completed">{metrics.onTimePercent}%</div>
              </div>
              <div className="performance-module-card completed">
                <div className="performance-module-title">Training Progress</div>
                <div className="performance-status-completed">{metrics.trainingProgress}</div>
              </div>
              <div className="performance-module-card completed">
                <div className="performance-module-title">Client Rating</div>
                <div className="performance-status-completed">⭐ {metrics.clientRating}</div>
              </div>
            </div>
          </div>

          {/* Achievements Section */}
          <div className="performance-section">
            <div className="performance-section-title">🏅 Achievements</div>
            {metrics.achievements.length > 0 ? (
              <div className="performance-module-grid">
                {metrics.achievements.map((item, index) => (
                  <div key={index} className="performance-module-card completed">
                    <div className="performance-module-title">{item}</div>
                    <div className="performance-status-completed">Unlocked</div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="performance-module-desc">No achievements unlocked yet. Keep going!</p>
            )}
          </div>

        </div>
      </div>
      <hr />
      <Footer />
    </div>
  );
};

export default PerformanceDashboard;
